export const LOGO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_fbc8f629-daa8-4e8a-a7ad-712d09cf131d/artifacts/b90d42f6e37b8cd7_0ffb06a0-cd60-11f1-a073-79b29723fc18.png";

export const CUNEIFORM_TEXTURE =
  "https://images.pexels.com/photos/27992278/pexels-photo-27992278.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const GOLD_TEXTURE =
  "https://images.unsplash.com/photo-1618352357270-ef40d25bcef8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGdvbGQlMjB0ZXh0dXJlfGVufDB8fHx8MTc5MjU5NTUxNXww&ixlib=rb-4.1.0&q=85";
